var e=(e,i=2)=>void 0===e?e:e.toString().includes(".")?Number(e).toFixed(i):e;export{e as roundNDecimal};
//# sourceMappingURL=roundNDecimal.js.map